(() => {
  'use strict';
  if (window.PremNewArrivals) { window.PremNewArrivals.mount(); return; }
  const states = new Map();
  function urlFor(path) {
    const url = new URL(path, location.origin);
    if (url.origin !== location.origin) throw new Error('new arrivals origin');
    url.searchParams.set('section_id', 'prem-new-arrivals-index');
    url.searchParams.set('sort_by', 'created-descending');
    const preview = new URL(location.href).searchParams.get('preview_theme_id') || (window.Shopify?.theme?.role === 'unpublished' ? String(window.Shopify.theme.id) : null);
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  }
  function collect(scope, rows) {
    const now = Date.now(), cutoff = now - 30 * 86400000;
    for (const item of scope.querySelectorAll('[data-new-candidate]')) {
      const created = Number(item.dataset.createdAt) * 1000, card = item.querySelector('.product-card[data-product-id]');
      if (card && created >= cutoff && created <= now && /^\d+$/.test(card.dataset.productId)) { const copy=card.cloneNode(true);copy.dataset.newCreated=String(created);rows.set(card.dataset.productId,copy); }
    }
  }
  function choose(rows, state) {
    const pool = [...rows.values()];
    for (let i=pool.length-1; i>0; i--) { const j=Math.floor(Math.random()*(i+1));[pool[i],pool[j]]=[pool[j],pool[i]]; }
    let previous=[];
    try { previous=JSON.parse(sessionStorage.getItem(state.key)||'[]'); } catch {}
    if (!Array.isArray(previous)) previous=[];
    const first=pool.slice(0,12), ids=first.map(card=>card.dataset.productId);
    if (ids.length && ids.length===previous.length && ids.every(id=>previous.includes(id))) {
      if (pool.length>12) [pool[0],pool[12]]=[pool[12],pool[0]];
      else if (pool.length>1 && ids.join(',')===previous.join(',')) pool.push(pool.shift());
    }
    return pool;
  }
  function show(state, number=1, scroll=false) {
    const now=Date.now();
    state.pool=state.pool.filter(card=>Number(card.dataset.newCreated)>=now-30*86400000 && Number(card.dataset.newCreated)<=now);
    const {root,grid,pager,status,pool}=state;
    const pages=Math.min(6,Math.ceil(pool.length/12));
    state.page=Math.min(number,Math.max(1,pages));
    grid.replaceChildren(...pool.slice((state.page-1)*12,state.page*12));
    grid.setAttribute('aria-busy','false');
    const focused=document.activeElement, hadPagerFocus=pager.contains(focused);
    for(let i=1;i<=pages;i++) {
      let button=pager.querySelector('[data-new-page-number="'+i+'"]');
      if(!button) {
        button=document.createElement('button');button.type='button';
        button.dataset.newPageNumber=String(i);button.textContent=String(i);
        button.setAttribute('aria-label',i+'페이지');
        button.addEventListener('click',()=>{state.interacted=true;show(state,i,true);});
        pager.append(button);
      }
      if(i===state.page)button.setAttribute('aria-current','page');
      else button.removeAttribute('aria-current');
    }
    for(const button of [...pager.children])if(Number(button.dataset.newPageNumber)>pages)button.remove();
    pager.hidden=pages<=1;
    if(hadPagerFocus && (pager.hidden || !focused.isConnected)) {
      const target=pager.hidden ? (root.querySelector('h2') || grid) : pager.querySelector('[aria-current="page"]');
      if(target){if(!target.hasAttribute('tabindex') && pager.hidden)target.setAttribute('tabindex','-1');target.focus({preventScroll:true});}
    }
    status.hidden=pool.length>0;
    status.textContent=pool.length?'':status.dataset.empty;
    root.dataset.newTotal=String(pool.length);
    if(state.page===1 && pool.length)try{sessionStorage.setItem(state.key,JSON.stringify(pool.slice(0,12).map(card=>card.dataset.productId)));}catch{}
    if(scroll)root.scrollIntoView({block:'start',behavior:window.matchMedia?.('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }
  async function request(path, signal) {
    const controller=new AbortController(),abort=()=>controller.abort();
    if(signal.aborted)abort();else signal.addEventListener('abort',abort,{once:true});
    const timer=setTimeout(abort,6000);
    try {
      const response=await fetch(urlFor(path),{credentials:'same-origin',signal:controller.signal});
      if(!response.ok){const error=new Error('new arrivals request');error.status=response.status;throw error;}
      const doc=new DOMParser().parseFromString(await response.text(),'text/html'),page=doc.querySelector('[data-new-page]');
      if(!page)throw new Error('new arrivals page');
      return page;
    } finally {clearTimeout(timer);signal.removeEventListener('abort',abort);}
  }
  async function refresh(state) {
    if(state.busy || !state.root.isConnected)return;
    if(state.pool.length)show(state,state.page);
    state.busy=true;state.controller=new AbortController();
    const signal=state.controller.signal,budget=setTimeout(()=>state.controller.abort(),12000);
    state.root.dataset.newReady='refreshing';
    if(!state.pool.length){state.status.hidden=false;state.status.textContent=state.status.dataset.loading;state.grid.setAttribute('aria-busy','true');}
    try {
      const rows=new Map(),first=await request(state.root.dataset.source,signal);
      collect(first,rows);
      if(!state.pool.length && rows.size){state.pool=choose(rows,state);show(state);}
      const next=first.dataset.next,total=Number(first.dataset.pages),param=first.dataset.pageParam;
      if(next && Number.isInteger(total) && total>1 && total<=1000 && /^page(?:_[\w]+)?$/.test(param||'')) {
        const pending=Array.from({length:total-1},(_,i)=>{const url=urlFor(next);url.searchParams.set(param,String(i+2));return url;});
        await Promise.all(Array.from({length:Math.min(3,pending.length)},async()=>{
          while(pending.length && !signal.aborted){const page=await request(pending.shift(),signal);collect(page,rows);}
        }));
      } else {
        let following=next;const seen=new Set();
        while(following){const url=urlFor(following);if(seen.has(url.href))throw new Error('new arrivals pagination');seen.add(url.href);const page=await request(url,signal);collect(page,rows);following=page.dataset.next;}
      }
      if(signal.aborted || !state.root.isConnected)throw new Error('new arrivals cancelled');
      let pool=choose(rows,state);
      if(state.interacted){const keep=state.pool.map(card=>rows.get(card.dataset.productId)).filter(Boolean),ids=new Set(keep.map(card=>card.dataset.productId));pool=[...keep,...pool.filter(card=>!ids.has(card.dataset.productId))];}
      state.pool=pool;show(state,state.page);
      state.root.dataset.newReady='true';state.retryable=false;state.lastRefresh=Date.now();
    } catch(error) {
      show(state,state.page);
      state.root.dataset.newReady='fallback';state.retryable=!error.status;
      state.status.hidden=state.pool.length>0;
      if(!state.pool.length)state.status.textContent=state.status.dataset.error;
    } finally {
      clearTimeout(budget);state.controller.abort();state.busy=false;state.grid.setAttribute('aria-busy','false');
    }
  }
  function mount() {
    for(const [root,state] of states)if(!root.isConnected){state.controller?.abort();states.delete(root);}
    document.querySelectorAll('[data-prem-new-arrivals]').forEach(root=>{
      if(states.has(root))return;
      if(!root.id)root.id='prem-new-'+root.dataset.sectionId;
      const state={root,grid:root.querySelector('.v5-feed-grid'),pager:root.querySelector('[data-new-pager]'),status:root.querySelector('[data-new-status]'),key:'prem.new-arrivals.previous.v1:'+root.dataset.sectionId,pool:[],page:1,interacted:false};
      states.set(root,state);const rows=new Map(),seed=root.querySelector('[data-new-seed]');
      if(seed)collect(seed.content,rows);
      state.pool=choose(rows,state);
      if(state.pool.length)show(state);
      refresh(state);
    });
  }
  window.PremNewArrivals={mount};mount();
  document.addEventListener('shopify:section:load',mount);
  document.addEventListener('shopify:section:unload',event=>{for(const [root,state] of states)if(event.target.contains(root)){state.controller?.abort();states.delete(root);}});
  window.addEventListener('online',()=>{for(const state of states.values())if(state.retryable)refresh(state);});
  window.addEventListener('pageshow',event=>{if(event.persisted)for(const state of states.values())refresh(state);});
})();
